// Central place for swappable site config (links, contact, etc).
// Update these values to swap globally.

export const SITE = {
  // The Calendly URL Ben books discovery calls through.
  calendlyUrl: "https://calendly.com/unclebenw/30min",

  // Email shown on the contact section.
  contactEmail: "hello@anchor-coaching.net",

  // Brand
  brandName: "ANCHOR",

  // Stripe Payment Links (live mode)
  pricing: {
    programText: {
      price: 49,
      label: "28-Day Program",
      link: "https://buy.stripe.com/6oUfZiaNv45h0Tp4ml5AQ00",
    },
    programAudio: {
      price: 99,
      label: "Audio Edition (Founding Member)",
      link: "https://buy.stripe.com/5kQ00kbRz7ht1Xt2ed5AQ01",
    },
    coachingFull: {
      price: 2000,
      label: "1:1 Coaching — Full Payment",
      link: "https://buy.stripe.com/3cIaEY4p7dFR1Xt6ut5AQ02",
    },
    coachingSplit: {
      price: 1050,
      label: "1:1 Coaching — 2-Payment Plan",
      link: "https://buy.stripe.com/28E5kEcVDfNZby34ml5AQ03",
    },
  },
};
